export type MarginPercentageParams = {
  machinePrice: number
  overAllowanceSplit: number
  proposedPrice: number
}

export function calculateMarginPercentage(
  params: MarginPercentageParams
): number {
  const margin =
    1 - params.machinePrice / (params.proposedPrice - params.overAllowanceSplit)

  return margin * 100
}
